export default __webpack_public_path__ + "static/media/trail_moving.c24aa8cb.svg";